import React, { FC } from 'react'
import { Header } from './header'
import { config } from 'config'
import MessagePage from 'pages/home/message-page'
import I18n from 'i18n-js'

export const MainLayout: FC = ({ children }) => {
  const mainBackgroundClass = config.isWecRedbutton
    ? 'bg-mainBackground_wec'
    : 'bg-mainBackground'
  return (
    <div className={`flex flex-col min-h-screen ${mainBackgroundClass}`}>
      <Header />
      {config.isWecRedbutton && (
        <div className="py-10">
          <a
            href="https://live-timing.fiawec.tv/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="text-xl font-semibold text-center underline text-primary">
              <MessagePage>{I18n.t('live-detail-page.livetiming')}</MessagePage>
            </div>
          </a>
        </div>
      )}
      <div className="flex-1 p-10">{children}</div>
    </div>
  )
}

export default MainLayout
